import * as Api from '@ViewModels';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { BASE_URL } from '../constants';

const BASE_QUERY_KEY = `/scheduler/<meetingId>/availability`;

const queryFn =
	({ meetingId, monthOffset }: { meetingId: string; monthOffset: number }) =>
	async () => {
		const response = await fetch(
			`${BASE_URL}/scheduler/${encodeURIComponent(meetingId)}/availability?monthOffset=${monthOffset}`
		);
		const data: Api.IOperationResult<Api.ISchedulerDailyIntervals[][]> = await response.json();
		if (!data.success) {
			throw new Error(data.systemMessage);
		}
		return data.value ?? [];
	};

export const useSchedulerAvailabilityQuery = ({
	meetingId,
	monthOffset = 0,
	enabled = true,
}: {
	meetingId: string;
	monthOffset?: number;
	enabled?: boolean;
}) => {
	return useQuery({
		queryFn: queryFn({ meetingId, monthOffset }),
		queryKey: [BASE_QUERY_KEY, meetingId, monthOffset],
		enabled,
	});
};

export const useSchedulerAvailabilitySuspenseQuery = ({
	meetingId,
	monthOffset = 0,
}: {
	meetingId: string;
	monthOffset?: number;
}) => {
	return useSuspenseQuery({
		queryFn: queryFn({ meetingId, monthOffset }),
		queryKey: [BASE_QUERY_KEY, meetingId, monthOffset],
	});
};

export const prefetchSchedulerAvailabilityQuery = async ({
	meetingId,
	monthOffset = 0,
}: {
	meetingId: string;
	monthOffset?: number;
}) => {
	reactQueryClient.prefetchQuery({
		queryFn: queryFn({ meetingId, monthOffset }),
		queryKey: [BASE_QUERY_KEY, meetingId, monthOffset],
	});
};
